import React from 'react';
import { Link } from '@smarterservices/smarter-ui';

interface RefreshLinkProps {
  /**
   * Optional class name for styling
   */
  className?: string;
  /**
   * Optional text to display in the link
   */
  text?: string;
}

/**
 * RefreshLink component for refreshing the page
 * 
 * @param {RefreshLinkProps} props - Component props
 * @returns {React.ReactElement} Link component for refreshing the page
 */
const RefreshLink: React.FC<RefreshLinkProps> = ({ className, text = 'Refresh' }) => {
  const handleClick = (e: React.MouseEvent) => {
    e.preventDefault();
    window.location.reload();
  };
  
  return (
    <Link
      href="#"
      onClick={handleClick}
      className={className}
      screenReaderLabel="Refresh window"
    >
      {text}
    </Link>
  );
};

export default RefreshLink;
